import { ADAPTIVE_SIZE } from './typings';

export function createCreativeSize(size: { w: number; h: number } | typeof ADAPTIVE_SIZE): string {
    if (size === ADAPTIVE_SIZE) {
        return size;
    } else {
        return `${size.w}x${size.h}`;
    }
}
